<template>
    <a-modal
    :title="title"
    :width="800"
    :ok=false
    :visible="visible"
    :confirmLoading="confirmLoading"
    :okButtonProps="{ props: {disabled: disableSubmit} }"
    @ok="handleOk"
    @cancel="handleCancel"
    :cancelText="$t('关闭')">
      <a-spin :spinning="confirmLoading">
        <a-tabs v-model="activeKey" @change="changeTab">
          <a-tab-pane :key="1" :tab="$t('数据详情')">
            <detail-list :col="2">
              <detail-list-item :term="$t('表编号')">{{model.meterId}}</detail-list-item>
              <detail-list-item :term="$t('表类型')">{{model.meterType?$t(meterTypeObj[model.meterType]):model.meterType}}</detail-list-item>
              <detail-list-item :term="$t('软件版本号')">{{model.meterSoftVersion}}</detail-list-item>
              <detail-list-item :term="$t('表安装地址')">{{model.userMeterAddr?model.userMeterAddr: '--'}}</detail-list-item>
              <detail-list-item :term="$t('运营商')">{{model.meterIotType?$t(netTypeObj[model.meterIotType]):model.meterIotType}}</detail-list-item>
              <detail-list-item :term="$t('失联天数')">{{model.lostContactDay}}</detail-list-item>
              <detail-list-item :term="$t('失联告警时间')">{{model.updateTime}}</detail-list-item>
              <detail-list-item :term="$t('处理状态')">{{model.meterDealStatus==2?$t('已处理'):model.meterDealStatus==1?$t('处理中'): $t('未处理')}}</detail-list-item>
              <detail-list-item :term="$t('处理描述')">{{model.meterDealStatus==2?model.meterWarnDealDescription2:model.meterDealStatus==1?model.meterWarnDealDescription1: model.meterWarnDealDescription0}}</detail-list-item>
            </detail-list>
          </a-tab-pane>
          <a-tab-pane :key="2" :tab="$t('历史失联告警记录')">
            <div class="form-contain">
              <div class="table-page-search-wrapper">
                <a-form layout="inline" @keyup.enter.native="searchQuery">
                  <a-row :gutter="24">
                    <a-col :xl="6" :lg="7" :md="8" :sm="24">
                      <a-form-item :label="$t('处理状态')">
                        <a-select v-model="queryParam.meterDealStatus" :placeholder="$t('请选择处理状态')">
                          <a-select-option value="0">
                            {{ $t('未处理') }}
                          </a-select-option>
                          <a-select-option value="1">
                            {{ $t('处理中') }}
                          </a-select-option>
                          <a-select-option value="2">
                            {{ $t('已处理') }}
                          </a-select-option>
                        </a-select>
                      </a-form-item>
                    </a-col>
                    <a-col :xl="12" :lg="7" :md="8" :sm="24">
                      <a-form-item :label="$t('告警日期')">
                        <a-range-picker
                          v-model="date"
                          format="YYYY-MM-DD"
                          :placeholder="[$t('查询起始时间'), $t('查询结束时间')]"
                          @change="onDateRangeChange"
                        />
                      </a-form-item>
                    </a-col>
                    <a-col :xl="8" :lg="7" :md="8" :sm="24">
                      <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
                      <a-button type="primary" @click="searchQuery" icon="search">{{ $t('查询') }}</a-button>
                      <a-button type="primary" @click="searchReset" icon="reload" style="margin-left: 8px">{{ $t('重置') }}</a-button>
                      </span>
                    </a-col>
                  </a-row>
                </a-form>
              </div>
              <div>
                <detail-list :col="3">
                  <detail-list-item :term="$t('表编号')">{{model.meterId}}</detail-list-item>
                  <detail-list-item :term="$t('表类型')">{{model.meterType?$t(meterTypeObj[model.meterType]):model.meterType}}</detail-list-item>
                  <detail-list-item :term="$t('运营商')">{{model.meterIotType?$t(netTypeObj[model.meterIotType]):model.meterIotType}}</detail-list-item>
                  <detail-list-item :term="$t('表安装地址')">{{model.userMeterAddr?model.userMeterAddr: '--'}}</detail-list-item>
                  <detail-list-item :term="$t('部门编号')">{{model.sysOrgCode}}</detail-list-item>
                  <detail-list-item :term="$t('部门名称')">{{model.departName}}</detail-list-item>
                </detail-list>
              </div>
              <div>
                <div class="ant-alert ant-alert-info" style="margin-bottom: 16px;">
                  <i class="anticon anticon-info-circle ant-alert-icon"></i> {{ $t('已选择 {count} 项', { count: selectedRowKeys.length }) }}
                  <a style="margin-left: 24px" @click="onClearSelected">{{ $t('清空') }}</a>
                  <a-button v-if="selectedRowKeys.length > 0" style="float: right;margin-left: 8px" type="primary" @click="batchDeal" size="small"> {{ $t('批量处理') }}</a-button>
                </div>
                <a-table 
                  :columns="columns"
                  :dataSource="dataSource"
                  :scroll="{x:true}"
                  rowKey='id'
                  size="middle"
                  :pagination="ipagination"
                  @change="handleTableChange"
                  :loading="loading"
                  class="j-table-force-nowrap"
                  :rowSelection="{selectedRowKeys: selectedRowKeys, onChange: onSelectChange,onSelect:onTableSelect,onSelectAll:onSelectAll,getCheckboxProps:getCheckboxProps}"
                >
                  <span slot="meterDealStatus" slot-scope="text, record">
                    <label v-if="record.meterDealStatus === 1" class="doing-status">{{ $t('处理中') }}</label>
                    <label v-else-if="record.meterDealStatus === 2" class="finish-status">{{ $t('已处理') }}</label>
                    <label v-else class="wait-status">{{ $t('未处理') }}</label>
                  </span>
                </a-table>
              </div>
            </div>
          </a-tab-pane>
        </a-tabs>
      </a-spin>
      <meter-warn-history-record-deal-modal ref="modalForm" @ok="modalFormOk"></meter-warn-history-record-deal-modal>
      <meter-warn-history-record-detail-modal ref="detailModalForm" @ok="modalFormOk"></meter-warn-history-record-detail-modal>
    </a-modal>
</template>

<script>

  import { httpAction, getAction } from '@/api/manage'
  import { JeecgListMixin } from '@/mixins/JeecgListMixin'
  import JFormContainer from '@/components/jeecg/JFormContainer'
  import {netTypeObj} from '@/utils/constants/protocolConstant'
  import {meterTypeObj} from '@/utils/constants/commonConstant'
  import DetailList from '@/components/tools/DetailList'
  const DetailListItem = DetailList.Item
  import meterWarnHistoryRecordDealModal from './meterWarnHistoryRecordDealModal'
  import meterWarnHistoryRecordDetailModal from './meterWarnHistoryRecordDetailModal'
  export default {
    name: 'MeterUserAccountForm',
    mixins:[JeecgListMixin],
    components: {
      JFormContainer,
      DetailList,
      DetailListItem,
      meterWarnHistoryRecordDealModal,
      meterWarnHistoryRecordDetailModal
    },
    data () {
      return {
        model: {},
        netTypeObj,
        meterTypeObj,
        title: '',
        confirmLoading: false,
        disableSubmit:false,
        visible: false,
        validatorRules: {
        },
        url: {
          list: "/jeecg-charge/meter/meterMaintenanceWarnRecord/warnPageList"
        },
        date:[],
        dateType: 2,
        activeKey: 1,
        disableMixinCreated: true,
        uniqueParam: {meterWarnType:3},
        /* 排序参数 */
        isorter:{
          column: 'updateTime',
          order: 'desc',
        },
      }
    },
    computed: {
      // i18n：表头使用 computed 以响应语言切换
      columns() {
        return [
          {
            title: '#',
            dataIndex: '',
            key:'rowIndex',
            width:60,
            align:"center",
            customRender: (t,r,index) => {
              return parseInt(index)+1;
            }
          },{
            title: this.$t('处理进度'),
            align:"center",
            dataIndex: 'meterDealStatus',
            scopedSlots: { customRender: 'meterDealStatus' },
            width:100,
            ellipsis: true
          },{
            title: this.$t('失联天数'),
            align:"center",
            dataIndex: 'lostContactDay',
            width: 100,
            ellipsis: true,
          },{
            title: this.$t('失联告警时间'),
            align:"center",
            dataIndex: 'updateTime',
            width:150,
            ellipsis: true
          },
        ]
      }
    },
    created () {
    },
    methods: {
      add () {
        this.edit({});
      },
      edit (record) {
        this.model = Object.assign({}, record);
        this.uniqueParam.meterId = this.model.meterId;
        this.changeTab(1);
        this.disableSubmit = true;
        this.visible = true;
      },
      shut() {
        this.activeKey = 1;
        this.queryParam = {};
        this.list = [];
        this.date = [];
        this.onClearSelected();
      },
      close () {
        this.$emit('close');
        this.shut();
        this.disableSubmit = false;
        this.visible = false;
      },
      handleOk () {
        const that = this;
        // 触发表单验证
        this.$refs.formModal.validate(valid => {
          if (valid) {
            that.confirmLoading = true;
            let httpurl = '';
            let method = '';
            if(!this.model.id){
              httpurl+=this.url.add;
              method = 'post';
            }else{
              httpurl+=this.url.edit;
              method = 'put';
            }
            httpAction(httpurl,this.model,method).then((res)=>{
              if(res.success){
                that.$message.success(res.message);
                setTimeout(() => {
                  that.$emit('ok');
                },400)
              }else{
                that.$message.warning(res.message);
              }
            }).finally(() => {
              that.confirmLoading = false;
              that.close();
            })

          }
        })
      },
      handleCancel () {
        this.close()
      },
      changeTab() {
        if(this.activeKey == 2) {
          this.loadData(1)
        }
      },
      handleDetail:function(record){
        this.$refs.detailModalForm.edit(record);
        this.$refs.detailModalForm.title=this.$t("详情");
        this.$refs.detailModalForm.disableSubmit = true;
      },
      handleEdit: function (record) {
        this.$refs.modalForm.edit(record);
        this.$refs.modalForm.title = this.$t("处理");
        this.$refs.modalForm.disableSubmit = false;
      },
      batchDeal() {
        // 批量处理告警
        if(this.selectionRows.length<1){
          this.$message.error(this.$t("请先选择需要批量处理的记录"))
          return
        }else{
          let idList = []
          let meterDealStatus = ''
          for(let i = 0;i<this.selectionRows.length;i++) {
            if(i === 0) {
              meterDealStatus = this.selectionRows[0].meterDealStatus
            }else{
              if(meterDealStatus !== this.selectionRows[i].meterDealStatus) {
                this.$message.error(this.$t("选择批量处理的处理进度不一致不能操作，请重新选择同一处理进度的表具"))
                return
              }
            }
            idList.push(this.selectionRows[i].id)
          }
          let record = {}
          record.idList = idList.join(',')
          record.meterDealStatus = meterDealStatus
          record.meterWarnType = this.uniqueParam.meterWarnType
          this.handleEdit(record)
        }
      },
      getCheckboxProps(record) {
        let props = {
          disabled: record.meterDealStatus == 2,
          meterDealStatus: record.meterDealStatus
        }
        return {props: {...props}};
      },
    }
  }
</script>
<style scoped>
.detail-list >>> .term{
  line-height: 22px;
}
</style>